import React from 'react';
//@ts-ignore
import {GetProductsBySite} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';
import ProductList from './../product-list/./product-list';

import TextOverImageThumbGrid from './../text-over-image-thumb-grid/./text-over-image-thumb-grid';

interface IProps {
  site?:string;
  active?:boolean;
  toggleSearch?:any;
  categories?: any;
  lines?: any;
}
interface IState {
  searchActive:boolean;
  products?:any;
  productResults?:any;
  updateKey?:any;
  contentActive?:boolean;
  value?:any;
}

/**
 *
 * HeaderSearch component
 * @extends {React.Component<IProps>}
 */

class HeaderSearch extends React.Component<IProps> {

  public state: IState;

  constructor (props: any) {
      super(props);
      this.state = {
        searchActive:false,
        updateKey:0
      };
  }

  public componentDidMount = async() => {
    setTimeout(() => {
      this.setState({
        contentActive:true
      })
    }, 100);
    let site:any = this.props.site;
    if(site == 'barefootinternational'){
      site = 'barefootInternational'
    }
    let products = await GetProductsBySite(site);
    const input = document.getElementById('search-input');
    if(input){
      input.focus();
    }
    this.setState({
      products:products,
      productResults:undefined
    })
  }
  public toggleSearch = () => {
    const input = document.getElementById('search-input');
    if(input){
      input.blur();
    }
    this.setState({
      value:undefined,
    },()=>{
      setTimeout(() => {
        this.setState({
          contentActive:false
        })
        this.props.toggleSearch()
      }, 100);
    })
  }

  public search = (e:any) => {
    let val = e.target.value;
    this.setState({
      value:val,
      productResults:undefined
    },()=>{
      if(val && val != ''){
        let value = val.toLowerCase();
        if(this.state.products){
          let products = this.state.products.filter((product:any) =>{
            if(product){
              if(product.attributes){
                if(product.attributes.content){
                  if(product.attributes.content[0]){
                    if(product.attributes.content[0].title){
                      return (product.attributes.content[0].title.toLowerCase().indexOf(value) != -1)
                    } else{
                      return false
                    }
                  } else{
                    return false
                  }
                } else{
                  return false
                }
              } else{
                return false
              }
            } else{
              return false
            }
          })
          this.setState({
            productResults:products,
            updateKey:this.state.updateKey+1
          })
        }
      }
    })
  }

  public render(): JSX.Element {
    let searchWrapperActiveClass:string = this.props.active ? "active" : "";
    let searchActiveClass:string = this.state.contentActive ? "active" : "";
    let closeAsset: string = this.props.site == 'hosports' ? GeneralAssetUrl+'close-black.png' : GeneralAssetUrl+'close-white.png';

    return (
      <>
        <div className={"search-wrapper "+searchWrapperActiveClass}>
          <div className={"search-wrapper-content primary-background "+searchActiveClass}>
            <div className="search-bar">
              <input id="search-input" className="search-input" onChange={(e:any)=>this.search(e)} placeholder="Search..." />
              <img className="search-bar-close" src={closeAsset} onClick={this.toggleSearch} />
            </div>
            {(this.state.productResults) ?
              <div className="search-results">
                <div className="search-product-results">
                  {this.state.value && this.state.value.length > 1 && <ProductList key={1+this.state.updateKey} products={this.state.productResults} />}
                  {this.state.value && this.state.value.length > 1 && this.state.productResults.length == 0 && <div className='small-adding full-width'>{'No Results Found'}</div>}
                </div>
              </div> :
              <div>
                {this.props.categories && <TextOverImageThumbGrid items={this.props.categories} smallColumns={'12'} mediumColumns={'4'} height={'25vh'} />}
              </div>
            }
          </div>
        </div>
      </>
    );
  }
}

export default HeaderSearch;
